import { render, staticRenderFns } from "./GBLayerBackground.vue?vue&type=template&id=368ae26d&"
import script from "./GBLayerBackground.vue?vue&type=script&lang=js&"
export * from "./GBLayerBackground.vue?vue&type=script&lang=js&"
import style0 from "./GBLayerBackground.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports